import { gql } from '@apollo/client';

export const TicketingUserFragment = gql`
  fragment TicketingUser on TicketingUser {
    id
    name
    email
    provider
    contributorId
  }
`;
